module.exports = __webpack_public_path__ + "img/balkon03.df06b0bf.jpg";